const style = {
    maincontainer: {
        marginLeft: 40
    },
    inputContainer: {
        // width: 900,
        height: 50
    },
    listButton: {
        backgroundColor: 'transparent',
        borderColor: 'transparent'
    }
};

export default style;